import { render, staticRenderFns } from "./card-professional.vue?vue&type=template&id=6ad9e286&scoped=true&"
import script from "./card-professional.vue?vue&type=script&lang=js&"
export * from "./card-professional.vue?vue&type=script&lang=js&"
import style0 from "./card-professional.vue?vue&type=style&index=0&id=6ad9e286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9e286",
  null
  
)

export default component.exports